import { BASE_URL } from '../constants';

const Ctrl = [function () {}];

export default {
  bindings: {},
  controller: Ctrl,
  templateUrl: `${BASE_URL}/em-product-tile-loader/em-product-tile-loader.template.html`,
};
